import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import type { Topic, TopicsRawData } from "../../../api-client/demandSearchTrendsTopicsAPI";

import { CATEGORY_LIST_WIDTH } from "./TopicsDiscoverAllTopicsModalMainSectionCategories";
import { TopicsDiscoverAllTopicsModalMainSectionTopicsColumn } from "./TopicsDiscoverAllTopicsModalMainSectionTopicsColumn";

const Spacer = styled.div`
    height: 16px;
    width: 100%;
`;

type TopicsDiscoverAllTopicsModalMainSectionPrimaryListProps = {
    data: TopicsRawData;
    activeCategoryName: string;
};

export const TopicsDiscoverAllTopicsModalMainSectionTopics = ({
    data,
    activeCategoryName,
}: TopicsDiscoverAllTopicsModalMainSectionPrimaryListProps) => {
    const topics = data[activeCategoryName]?.Children || {};
    const topicsArray = Object.values(topics);
    const leftColumnTopics: Topic[] = [];
    const rightColumnTopics: Topic[] = [];

    topicsArray.forEach((topic, index) => {
        if (index % 2 === 0) {
            leftColumnTopics.push(topic);
        } else {
            rightColumnTopics.push(topic);
        }
    });

    return (
        <Flex
            overflow="auto"
            flexDirection="column"
            width={`calc(100% - ${CATEGORY_LIST_WIDTH}px)`}
        >
            <Flex
                flex="1"
                gap="16px"
                padding="16px"
                justifyContent="center"
            >
                <TopicsDiscoverAllTopicsModalMainSectionTopicsColumn
                    topics={leftColumnTopics}
                    columnPlacement="left"
                />
                <TopicsDiscoverAllTopicsModalMainSectionTopicsColumn
                    topics={rightColumnTopics}
                    columnPlacement="right"
                />
            </Flex>
            <Spacer />
        </Flex>
    );
};
